/**
 * Helper to manage AJAX request in a form
 *
 * @property {string} alertSelector Selector for alert element
 * @property {string} alertSuccessClass HTML class for success alert
 * @property {string} alertErrorClass HTML class for error alert
 * @property {string} btnSelector Selector for submit button in form
 */
class AjaxFormManager {
  constructor() {
    if (typeof jQuery === 'undefined') {
      throw new Error('Jquery is required to uses WeHealth References Block');
    }

    this.alertSelector = '.ajax-alert';
    this.alertSuccessClass = 'alert-success';
    this.alertErrorClass = 'alert-danger';
    this.btnSelector = '.submit';
  }

  /**
   * Hide alerts and clean classes in form
   *
   * @param {jQuery} $form Alerts form element
   */
  cleanAlerts($form) {
    $form
      .find(this.alertSelector)
      .hide()
      .removeClass([this.alertErrorClass, this.alertSuccessClass].join(' '));
  }

  /**
   * Display an alert in form
   *
   * @param {jQuery} $form Alert form element
   * @param {bool} success if is a success alert (Default false)
   * @param {string} message Alert message
   */
  displayAlert($form, success = false, message = '') {
    this.cleanAlerts($form);

    $form
      .find(this.alertSelector)
      .addClass(
        success === true ? this.alertSuccessClass : this.alertErrorClass
      )
      .text(message)
      .show('fast');
  }

  /**
   * Send AJAX request
   *
   * @param {string} url Request URL
   * @param {string} action Ajax action name
   * @param {jQuery} $form Form element
   * @param {bool} reset If the form needs to be reset after the request is successful (Default: false)
   *
   * @returns {Promise} With request data
   */
  sendRequest(url, action, $form, reset = false) {
    return new Promise((resolve, reject) => {
      this.cleanAlerts($form);

      let $btn = $form.find(this.btnSelector);

      // prepare data
      let data = $form.serializeJSON();
      data.action = action;

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: url,
        data: data,
        beforeSend: () => {
          $btn.attr('disabled', true);
        },
        success: (data) => {
          this.displayAlert($form, data.success, data.message);

          if (!data.success) {
            this.displayAlert($form, false, data.message);
          } else if (reset === true) {
            $form[0].reset();
          }

          resolve(data);
        },
        error: () => {
          this.displayAlert(
            $form,
            false,
            'TECHNICAL ERROR: please try again later.'
          );
          reject();
        },
        complete: () => {
          $btn.attr('disabled', false);
        },
      });
    });
  }
}

export default new AjaxFormManager();



// WEBPACK FOOTER //
// ./scripts/classes/AjaxFormManager.js